import { useMemo } from 'react';
import { usePromise } from '../hooks/usePromise';
import { AsyncResult } from '../types/AsyncResult';
import { parseFromFetchResponse, Validator } from '../util/parse';
import { Globals } from './Globals';
import { useServices } from './Services';

export class NetworkService {
  constructor(private globals?: Globals) {}

  fetch = async (input: RequestInfo, init?: RequestInit): Promise<Response> => {
    if (!this.globals?.fetch) return new Promise(() => void null);
    return this.globals.fetch(input, init);
  };

  sendBeacon = async (url: string, body?: string): Promise<void> => {
    if (this.globals?.navigator?.sendBeacon) {
      this.globals.navigator.sendBeacon(url, body);
    } else {
      await this.fetch(url, { body: body, method: 'POST', keepalive: true });
    }
  };
}

export const useFetch = () => useServices().network.fetch;

export type Fetch = NetworkService['fetch'];

export const useFetchedJson = <T>(url: string, validator: Validator<T>): AsyncResult<T> => {
  const fetch = useFetch();

  const state = usePromise(
    useMemo(async () => {
      const fetched = await fetch(url);
      return parseFromFetchResponse(fetched, validator);
    }, [fetch, url, validator]),
  );

  return state;
};
